export async function showAlert(
  title: string,
  message?: string,
): Promise<void> {
  alert(message ?? title);
}
